
const MainImage = () => {
    return <div>
        <img className="main-image" alt="A group of people sitting at a desk" title="A group of people sitting at a desk"
            src="/aarlMain.jfif" />
    </div>
}

export default MainImage